var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-tooltip",
    {
      attrs: {
        "append-to-body": _vm.appendToBody,
        triggers: ["click", "hover", "focus"],
        "auto-close": "",
        multilined: "",
        position: "is-right",
        position: _vm.position,
        size: "is-large",
        type: "is-light",
      },
      scopedSlots: _vm._u([
        {
          key: "content",
          fn: function () {
            return [
              _c("div", { staticClass: "card white" }, [
                _vm.cardImage && _vm.imageEnabled
                  ? _c("div", { staticClass: "card-image" }, [
                      _c("figure", { staticClass: "image is-1by1" }, [
                        _c("img", {
                          attrs: { alt: _vm.cardImageAlt, src: _vm.cardImage },
                        }),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "content" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.cardText) + "\n        "
                    ),
                  ]),
                ]),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("b-icon", {
        attrs: { icon: "question-circle", size: "is-medium", type: "is-info" },
        on: { hover: _vm.showCard },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }